import React from "react";
import "./portfolio.css";
import dashboard from "../../assets/portfolio/dashboard.jpg";
import landing from "../../assets/portfolio/landing.jpg";
import reservation from "../../assets/portfolio/reservation.jpg";
import weather from "../../assets/portfolio/weather.jpg";
import flight from "../../assets/portfolio/flight.jpg";
import famid from "../../assets/portfolio/famid.jpg";
import urbond from "../../assets/portfolio/urbond.png";
import volley from "../../assets/portfolio/volley.png";

const Portfolio = () => {
  return (
    <section id="portfolio">
      <h5>My recent work</h5>
      <h2>Portfolio</h2>
      <div className="container portfolio__container">
        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={urbond} alt="dashboard" />
          </div>
          <h3>URBOND</h3>
          <div className="portfolio__item-cta">
            <a href="#" className="btn" target="_blank" rel="noreferrer">
              Github
            </a>
            <a
              href="https://urbond.org/"
              className="btn btn-primary"
              target="_blank"
              rel="noreferrer"
            >
              Live Demo
            </a>
          </div>
        </article>
        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={volley} alt="dashboard" />
          </div>
          <h3>Volley Ball</h3>
          <div className="portfolio__item-cta">
            <a href="#" className="btn" target="_blank" rel="noreferrer">
              Github
            </a>
            <a
              href="https://volleyball.urbond.org/"
              className="btn btn-primary"
              target="_blank"
              rel="noreferrer"
            >
              Live Demo
            </a>
          </div>
        </article>
        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={dashboard} alt="dashboard" />
          </div>
          <h3>Dashboard</h3>
          <div className="portfolio__item-cta">
            <a
              href="https://github.com/fcammy/admin-dashboard"
              className="btn"
              target="_blank"
              rel="noreferrer"
            >
              Github
            </a>
            <a
              href="https://fcammy.github.io/admin-dashboard/"
              className="btn btn-primary"
              target="_blank"
              rel="noreferrer"
            >
              Live Demo
            </a>
          </div>
        </article>
        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={landing} alt="dashboard" />
          </div>
          <h3>Landing page</h3>
          <div className="portfolio__item-cta">
            <a
              href="https://github.com/fcammy/landingpage"
              className="btn"
              target="_blank"
              rel="noreferrer"
            >
              Github
            </a>
            <a
              href="https://fcammy.github.io/landingpage/"
              className="btn btn-primary"
              target="_blank"
              rel="noreferrer"
            >
              Live Demo
            </a>
          </div>
        </article>
        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={reservation} alt="dashboard" />
          </div>
          <h3>Hotel booking </h3>
          <div className="portfolio__item-cta">
            <a
              href="https://github.com/fcammy/Reservia"
              className="btn"
              target="_blank"
              rel="noreferrer"
            >
              Github
            </a>
            <a
              href="https://fcammy.github.io/Reservia/"
              className="btn btn-primary"
              target="_blank"
              rel="noreferrer"
            >
              Live Demo
            </a>
          </div>
        </article>
        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={weather} alt="weather" />
          </div>
          <h3>Weather App </h3>
          <div className="portfolio__item-cta">
            <a
              href="https://github.com/fcammy/weather_app"
              className="btn"
              target="_blank"
              rel="noreferrer"
            >
              Github
            </a>
            <a
              href="https://willowy-travesseiro-51a98e.netlify.app/"
              className="btn btn-primary"
              target="_blank"
              rel="noreferrer"
            >
              Live Demo
            </a>
          </div>
        </article>
      </div>
    </section>
  );
};

export default Portfolio;
